<template>
  <div class="screen-wrapper" :style="screenWrapperStyle">
    <div class="screen" data-model-id="8:906" :style="screenStyle">
      <BannerCarousel />

      <HeaderSubsection />

      <AchievementShowcase />

      <Group3Subsection :top="2980" />
    </div>
  </div>
</template>

<script>
import BannerCarousel from "../components/BannerCarousel.vue";
import Group3Subsection from "./Screen/sections/Group3Subsection.vue";
import HeaderSubsection from "./Screen/sections/HeaderSubsection.vue";
import AchievementShowcase from "./Screen/sections/AchievementShowcase.vue";

export default {
  name: "Screen",
  components: {
    BannerCarousel,
    Group3Subsection,
    HeaderSubsection,
    AchievementShowcase,
  },
  data() {
    return {
      baseWidth: 1920,
      baseHeight: 3213,
      targetWidth: 1920,
      viewportWidth: 0,
    };
  },
  mounted() {
    this.viewportWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    window.addEventListener("resize", this.onResize);
  },
  computed: {
    scale() {
      const w = this.viewportWidth || this.targetWidth;
      const clamped = Math.min(w, this.baseWidth);
      return clamped / this.baseWidth;
    },
    screenStyle() {
      return {
        transform: `scale(${this.scale})`,
        transformOrigin: "top left",
        width: this.baseWidth + "px",
        height: this.baseHeight + "px",
        position: "relative",
      };
    },
    screenWrapperStyle() {
      return {
        width: "100%",
        height: this.baseHeight * this.scale + "px",
        minHeight: this.baseHeight * this.scale + "px",
      };
    },
  },
  methods: {
    onResize() {
      this.viewportWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
    },
  },
};
</script>

<style scoped>
.screen-wrapper {
  width: 100%;
  position: relative;
  overflow: visible;
}

.screen {
  background-color: #07183a;
  position: relative;
  width: 100%;
  height: auto;
  overflow: visible;
}

@media (min-width: 1920px) {
  .screen-wrapper {
    max-width: 1920px;
    margin: 0 auto;
  }
}
</style>
